import mockData from './mock';
import { apiToApp } from './serverApi';

const DELAY = 1000;

export const loadInviter = () => {
  return new Promise(resolve =>
    setTimeout(() => resolve(mockData), DELAY),
  ).then(apiToApp);
};

export { apiToApp };
